import React, {useState, useEffect} from 'react'
import classes from './EmailVerification.module.css'
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import firebase from "../../Config/firebase";
import {MDBContainer, MDBRow, MDBCol, MDBAlert} from "mdbreact";
import {isAuth} from "../../Utils/firebaseUtils";

const db = firebase.firestore()


const EmailVerification = (props) => {
    const [isVerifying, setIsVerifying] = useState(false)
    const [finalState, setFinalState] = useState('')

    useEffect(() => {
        async function submitData() {
            if (props.match.params.hasOwnProperty('vid') && isAuth(props.auth)) {
                setIsVerifying(true)
                await fetch("/api/member/verifyRequest", {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        uid: props.auth.uid,
                        verifyToken: props.match.params.vid
                    })
                }).then((res) => res.json()).then((finalResponse) => {
                    if (finalResponse.success) {
                        setFinalState(finalResponse.state)
                        setIsVerifying(false)
                    }
                })
            }
        }

        submitData()
        // return new Promise(async (resolve, reject) => {

        // })
    }, [props.auth.uid])

    return (
        <MDBContainer>
            <MDBRow>
                <MDBCol>
                    {
                        isVerifying ?
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            : ''
                    }

                    {
                        finalState === "REVIEWING" ?
                            <MDBAlert color='success'>
                                已經完成！ 我們正在檢閱你的申請，申請完成後你將會收到電郵
                            </MDBAlert> : ""
                    }

                    {
                        finalState === "FINISHED" ?
                            <MDBAlert color='success'>
                                已經完成，請重新登入啟用新功能
                            </MDBAlert> : ""
                    }

                    {
                        finalState === "UID_NOT_MATCH_USER" || finalState === "INVALID_TOKEN" ?
                            <MDBAlert color='danger'>
                                無效的啟用碼
                            </MDBAlert> : ""
                    }
                </MDBCol>
            </MDBRow>

        </MDBContainer>
    )
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)
export default enhance(withRouter(EmailVerification))